import { Injectable } from '@angular/core';
import { AppEnv, MenuItem } from '@app/Shared/interfaces/iMenu';
import { APP_MENU_ITEMS } from '@app/Shared/constants/menu.config';

@Injectable({
    providedIn: 'root',
})
export class MenuAccessService {
    getCurrentEnv(): AppEnv {
        const hostname = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();

        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'dev';
        }
        if (hostname === 'cg-truedata.com' || hostname.endsWith('.cg-truedata.com')) {
            return 'prod';
        }
        if (hostname === 'cg-truedata-staging.com' || hostname.endsWith('.cg-truedata-staging.com')) {
            return 'staging';
        }
        if (hostname === 'cg-truedata-test.com' || hostname.endsWith('.cg-truedata-test.com')) {
            return 'test';
        }
        if (hostname === 'cg-truedata-dev.com' || hostname.endsWith('.cg-truedata-dev.com')) {
            return 'dev';
        }

        return 'dev';
    }

    isMenuAllowed(item: MenuItem): boolean {
        if (!item.allowedEnvs || item.allowedEnvs.length === 0) {
            return true;
        }
        return item.allowedEnvs.includes(this.getCurrentEnv());
    }

    getVisibleMenus(items: MenuItem[]): MenuItem[] {
        return items.filter((item) => this.isMenuAllowed(item));
    }

    isPathAllowed(path: string): boolean {
        const normalizedPath = (path || '').split('?')[0].split('#')[0];
        if (!normalizedPath || normalizedPath === '/') {
            return true;
        }

        const matchingMenu = APP_MENU_ITEMS.find((item) => {
            if (!item.page) {
                return false;
            }
            return normalizedPath === item.page || normalizedPath.startsWith(`${item.page}/`);
        });

        if (!matchingMenu) {
            return true;
        }

        return this.isMenuAllowed(matchingMenu);
    }
}
